import { Stack } from "expo-router";
import { ActivityIndicator } from "react-native";
import { AnnouncementsPage } from "@visioni/a3s-notifications/app";
import { View } from "@src/components";
import { WebLayout } from "@src/components/web/WebLayout.web";
import { SupportAccessRestricted } from "@src/components/web/SupportAccessRestricted.web";
import { useSupportUserStatus } from "@src/features/tenants";
import { authenticatedFetch } from "@src/features/auth";
import { useEnvironment } from "@src/config/environment-store";
import { directory } from "@src/config/runtime";

/**
 * Support-only feature announcements. They call the root API (no tenant), so
 * the page lives under Settings. Gated here, like Patriot tools, so a denied
 * user never mounts the page's data hooks; the API refuses non-support
 * callers regardless.
 */
export default function AnnouncementsScreen() {
  const supportStatus = useSupportUserStatus();
  const environment = useEnvironment();

  return (
    <>
      <Stack.Screen options={{ headerShown: false }} />
      <WebLayout>
        {supportStatus === "granted" ?
          <AnnouncementsPage
            isProduction={environment.key === "prd"}
            api={{ authenticatedFetch, directoryBaseUrl: directory(environment) }}
          />
        : supportStatus === "denied" ?
          <SupportAccessRestricted />
          // Roles not yet known. Waiting rather than denying, so a cold deep
          // link does not show the restricted notice to a support user.
        : <View flex={1} alignItems="center" justifyContent="center">
            <ActivityIndicator />
          </View>
        }
      </WebLayout>
    </>
  );
}
